import React from 'react'
import { Box, Typography } from '@mui/material';
import { getIconAndLabel } from '../../../Utilities/SocialMediaMapping'

const SocialNetwork = ({activeProfile, socialLinks}) => {
    const userSocialLinks = socialLinks;
  
    const anySocialIconsVisible = userSocialLinks?.some(link => link && link.visible);

  return (
    <Box className='sidefeed-box social-network-box my-2'> 
    <div className="sidefeed-titles mb-2">
        Social Network
    </div>
    {anySocialIconsVisible ? (
        <Box className="social-icons-rows">
          {userSocialLinks.map((link) => (
            link.visible && (
              <a key={link.network} href={link.url} target='_blank' rel='noopener noreferrer'>
                <Box className="square-box">
                  {(() => {
                    const { icon: Icon } = getIconAndLabel(link.network);
                    return Icon ? <Icon className="social-icon svg-icon-32px" /> : null;
                  })()}
                </Box>
              </a>
            )
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No social links added!
        </Typography>
      )}
    </Box>
  )
}

export default SocialNetwork

